import { render, staticRenderFns } from "./quickStart.vue?vue&type=template&id=1f49f488&scoped=true"
import script from "./quickStart.js?vue&type=script&lang=js&external"
export * from "./quickStart.js?vue&type=script&lang=js&external"
import style0 from "./quickStart.vue?vue&type=style&index=0&id=1f49f488&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f49f488",
  null
  
)

export default component.exports